import { combineReducers } from 'redux';

import apps from './apps/index';
import vendors from './vendors';

export default combineReducers({
  apps,
  vendors,
});
